/**
 * SystemNotification Component
 * 
 * A component that renders system-wide notifications using the SystemNotificationProvider context.
 * Should be placed at the root level of the app to show notifications above all other content.
 */

import React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { NotificationCard } from '../crop-circle/Components/NotificationCard';
import { useSystemNotification } from './system-notification-provider';

export const SystemNotification: React.FC = () => {
  const { notifications } = useSystemNotification();
  const animationDuration = 300;

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <View
      style={styles.notificationOverlay}
      pointerEvents="auto"
    >
        {
          notifications.map((notification) => (
            <Animated.View
              key={notification.id}
              style={{
                ...styles.notificationCardContainer,
              }}
              entering={FadeIn.duration(animationDuration)}
              exiting={FadeOut.duration(animationDuration)}
            >
              <NotificationCard
                title={notification.title}
                text={notification.text}
                style={notification.style}
                leftIcon={notification.leftIcon}
                showLeftIcon={notification.showLeftIcon}
                full
                showButtons={false}
              />
            </Animated.View>
          ))
        }
    </View>
  );
};

const styles = StyleSheet.create({
  notificationOverlay: {
    width: '100%',
    height: 'auto',
    position: 'absolute',
    top: 0,
    padding: 10,
    zIndex: 1000,
  },
  notificationCardContainer: {
    marginBottom: 10,
  },
});